export default __webpack_public_path__ + "static/media/empty-list.f5970006.svg";